import { Pipe, PipeTransform, inject } from '@angular/core';
import { FormattingService } from '@settings/data-access';

@Pipe({ 
    name: 'formatNumberIntl',
})
export class FormatNumberIntlPipe implements PipeTransform {
  private readonly formattingService = inject(FormattingService);

  public transform(value: string | number, decimals?: number, locale?: string): string {
    return this.formattingService.formatNumber(value, decimals, locale);
  }
}